"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogBrowserHeaderInternal = exports.CatalogBrowserHeader = exports.CatalogBrowserSubplace = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_router_1 = require("react-router");
var reselect_1 = require("reselect");
var Localize_1 = require("../../../gen-src/Localize");
var CatalogBrowserSelectorItem_1 = require("./CatalogBrowserSelectorItem");
var Header = data_catalog_shared_1.divWithStyle('CatalogBrowserHeader', [
    data_catalog_shared_1.flexRowStyle,
    data_catalog_shared_1.headerPaddingStyle,
    data_catalog_shared_1.spaceHeaderContentStyle,
]);
var Title = data_catalog_shared_1.divWithStyle('CatalogBrowserTitle', data_catalog_shared_1.nonPlaceTitleStyle);
var Selector = data_catalog_shared_1.divWithStyle('CatalogBrowserSelector', {
    paddingLeft: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
});
var GraphiQLLink = data_catalog_shared_1.divWithStyle('CatalogBrowserGraphiQLLink', {
    flex: 1,
    textAlign: 'right',
});
var CatalogBrowserSubplace;
(function (CatalogBrowserSubplace) {
    CatalogBrowserSubplace["Databases"] = "Databases";
    CatalogBrowserSubplace["Tables"] = "Tables";
})(CatalogBrowserSubplace = exports.CatalogBrowserSubplace || (exports.CatalogBrowserSubplace = {}));
var CatalogBrowserHeader = /** @class */ (function (_super) {
    __extends(CatalogBrowserHeader, _super);
    function CatalogBrowserHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogBrowserHeader.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_router_1.Route, null, function (_a) {
            var history = _a.history;
            return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) { return (React.createElement(data_catalog_shared_1.UrlSearchProvider, null, function (urlSearch) { return (React.createElement(CatalogBrowserHeaderInternal, { databasesCount: _this.props.databasesCount, tablesCount: _this.props.tablesCount, selectedSubplace: _this.props.selectedSubplace, history: history, urls: urls, urlSearch: urlSearch })); })); }));
        }));
    };
    return CatalogBrowserHeader;
}(React.Component));
exports.CatalogBrowserHeader = CatalogBrowserHeader;
var CatalogBrowserHeaderInternal = /** @class */ (function (_super) {
    __extends(CatalogBrowserHeaderInternal, _super);
    function CatalogBrowserHeaderInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line: typedef
        _this.memoizedCreateSubplaceList = reselect_1.defaultMemoize(createSubplaceList);
        _this.renderDropdown = function () {
            var items = _this.memoizedCreateSubplaceList(_this.props.databasesCount, _this.props.tablesCount);
            return (React.createElement(Selector, null,
                React.createElement(widgets_1.SingleSelectDropdown, { type: widgets_1.DropdownButtonType.Line, label: '', list: React.createElement(widgets_1.List, { items: items, selectedValue: _this.props.selectedSubplace }), value: _this.props.selectedSubplace, onChange: _this.onChangeSubspace, style: { fontSize: 14 } }, _this.props.selectedSubplace === CatalogBrowserSubplace.Databases
                    ? Localize_1.Messages.DatabasesAndFiles()
                    : Localize_1.Messages.Tables())));
        };
        _this.onChangeSubspace = function (value) {
            if (_this.props.selectedSubplace !== value) {
                switch (value) {
                    case CatalogBrowserSubplace.Databases:
                        _this.props.history.push(_this.props.urls.catalogDatabasesPath() + _this.props.urlSearch.value);
                        break;
                    case CatalogBrowserSubplace.Tables:
                        _this.props.history.push(_this.props.urls.catalogTablesPath() + _this.props.urlSearch.value);
                        break;
                    default:
                        break;
                }
            }
        };
        return _this;
    }
    CatalogBrowserHeaderInternal.prototype.render = function () {
        return (React.createElement(Header, null,
            React.createElement(Title, null, Localize_1.Messages.ExternalAssets()),
            this.renderDropdown(),
            React.createElement(GraphiQLLink, null,
                React.createElement("a", { href: '/metadata/graphiql/' }, Localize_1.Messages.QueryMetadataGraphiQL()))));
    };
    return CatalogBrowserHeaderInternal;
}(React.Component));
exports.CatalogBrowserHeaderInternal = CatalogBrowserHeaderInternal;
function createSubplaceList(databasesCount, tablesCount) {
    return [
        {
            value: CatalogBrowserSubplace.Databases,
            content: (React.createElement(CatalogBrowserSelectorItem_1.CatalogBrowserSelectorItem, { subplaceName: Localize_1.Messages.DatabasesAndFiles(), count: databasesCount })),
        },
        {
            value: CatalogBrowserSubplace.Tables,
            content: (React.createElement(CatalogBrowserSelectorItem_1.CatalogBrowserSelectorItem, { subplaceName: Localize_1.Messages.Tables(), count: tablesCount })),
        },
    ];
}
//# sourceMappingURL=CatalogBrowserHeader.js.map